import React, { Component, Fragment } from "react";
import _ from "lodash";
import { ButtonGroup, Button, Modal } from "../../components";
import { multiLanguage } from "../../hoc";
import { assetsPath } from "../../utils";
import ArrowRight from "../../components/icons/ArrowRight";
import ArrowLeft from "../../components/icons/ArrowLeft";
import Popup from "./components/popup";

@multiLanguage()
export default class Siteplan extends Component {
  state = {
    openModal: false,
    selectedType: "all",
    selectedBuilding: "all",
    pageModal: "1st",
    selectedSubTab: "all",
    pageModalSiteplan: "",
    pageModalData: null,
    popupHover: "",
    width: window.innerWidth,
  };

  hover = () => {
    const allEl = document.querySelectorAll(
      "#floorplan path, #floorplan polygon, #floorplan rect"
    );
    for (let i = 0; i < allEl.length; i += 1) {
      allEl[i].addEventListener("mouseover", this.handleUnitHover);
    }
  };
  unhover = () => {
    const allEl = document.querySelectorAll(
      "#floorplan path, #floorplan polygon, #floorplan rect"
    );
    for (let i = 0; i < allEl.length; i += 1) {
      allEl[i].addEventListener("mouseout", this.handleUnitUnHover);
    }
  };

  handleUnitUnHover = (e) => {
    this.setState({
      popupHover: "",
    });
  };

  handleUnitHover = (e) => {
    const currentHoverType = e.target.parentElement.id;
    this.setState({
      popupHover: currentHoverType,
    });
  };
  componentDidUpdate(prevProps) {
    this.hover();
    this.unhover();
    if (this.props.dataSitePlan !== prevProps.dataSitePlan) {
      !_.isEmpty(this.props.dataSitePlan) && this.test("all");
    }
  }
  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  };

  updateDimensions = () => {
    const { width } = this.state;
    this.setState({
      width: window.innerWidth,
    });
  };
  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateDimensions);
  };
  test = (val) => {
    const { pageModal } = this.state;
    const { dataSitePlan } = this.props;
    const findPageModalData = _.find(
      dataSitePlan,
      ({ value }) => value === pageModal
    );
    console.log("............ test", {
      val,
      dataSitePlan,
      findPageModalData,
      pageModal,
    });

    this.setState({
      pageModalData: findPageModalData || {},
      selectedSubTab: val,
    });
  };
  handleCloseModal = () => {
    this.setState({
      openModal: false,
      selectedType: "all",
      pageModal: "1st",
      pageModalSiteplan: "",
      pageModalData: null,
    });
  };

  handleClickForOpenModal = (pageModal) => {
    const { dataSitePlan } = this.props;
    const findPageModalData = _.find(
      dataSitePlan,
      ({ value }) => value === pageModal
    );
    this.setState({
      openModal: true,
      selectedType: "all",
      pageModal,
      pageModalData: findPageModalData || {},
    });
  };

  handleSliderRight = () => {
    const { dataSitePlan } = this.props;
    const { pageModal } = this.state;

    const sliderCurrentIndex = _.findIndex(
      dataSitePlan,
      ({ value }) => value === pageModal
    );

    const lastDataSitePlanIndex = dataSitePlan.length - 1;
    const sliderNextIndex =
      sliderCurrentIndex === lastDataSitePlanIndex ? 0 : sliderCurrentIndex + 1;
    const nextModal = _.get(dataSitePlan, [sliderNextIndex]);
    const nextPageModal = _.get(nextModal, "value");
    console.log("handleSliderRight", {
      sliderCurrentIndex,
      nextModal,
      nextModal,
    });
    this.setState({
      pageModal: nextPageModal,
      pageModalData: nextModal || {},
    });
  };

  handleSliderLeft = () => {
    const { dataSitePlan } = this.props;
    const { pageModal } = this.state;
    const sliderCurrentIndex = _.findIndex(
      dataSitePlan,
      ({ value }) => value === pageModal
    );
    const lastDataSitePlanIndex = dataSitePlan.length - 1;
    const sliderNextIndex =
      sliderCurrentIndex === 0 ? lastDataSitePlanIndex : sliderCurrentIndex - 1;
    const nextModal = _.get(dataSitePlan, [sliderNextIndex]);
    const nextPageModal = _.get(nextModal, "value");
    this.setState({
      pageModal: nextPageModal,
      pageModalData: nextModal || {},
    });
  };

  handleChangeType = (selectedType) => {
    this.setState({
      selectedType,
    });
  };

  handleChangeSubTab = (selectedSubTab) => {
    this.setState({
      selectedSubTab,
    });
  };

  handleBlock = (valueBlock) => {
    const { pageModal } = this.state;
    const { dataSitePlan } = this.props;
    const findPageModalData = _.find(
      dataSitePlan,
      ({ value }) => value === pageModal
    );
    console.log("handleBlock", { valueBlock, dataSitePlan, pageModal });

    this.setState({
      pageModalData: findPageModalData || {},
      selectedSubTab: valueBlock,
    });
  };

  renderPopup = () => {
    const { descriptions, t } = this.props;
    const { popupHover } = this.state;
    const mapHoverData = _.map(descriptions, (item) => {
      const getTypePopup = _.get(item, "value");
      // const getDataPopup = _.get(item, "title");
      const getTitlePopup = _.get(item, "title");
      const getDataPopup = _.get(item, "des");
      const activePopup = getTypePopup === popupHover ? "active" : "";
      // console.log("renderPopup", {
      //   item,
      //   getTypePopup,
      //   getDataPopup,
      //   activePopup,
      // });
      // console.log("renderPopup", { getTypePopup, popupHover, getTypePopup });
      return (
        <Popup
          title={t(getTitlePopup)}
          data={t(getDataPopup)}
          active={activePopup}
          onclick={this.handleUnitHover}
        />
      );
    });
    return mapHoverData;
  };

  renderAllFloor = () => {
    // const selectedSubTab = "a";
    // const { selectedType, pageModalData, width } = this.state;
    const { selectedSubTab, selectedType, pageModalData, width } = this.state;
    const { subTabs, currentLanguage, t } = this.props;

    let CurrentBlocks = () => {
      return null;
    };
    const showImg = _.find(subTabs, ({ value }) => value === selectedSubTab);
    const mapElement = _.get(
      pageModalData,
      `floorPlan.${selectedSubTab}`,
      null
    );
    console.log("renderAllFloor", { subTabs, selectedSubTab, pageModalData });
    if (mapElement) {
      CurrentBlocks = mapElement;
    } else {
      if (showImg) {
        CurrentBlocks = showImg.img;
      }
    }
    console.log("SEASIDE RESIDENCES SITE-PLAN", {
      subTabs,
      currentLanguage,
      selectedSubTab,
      selectedType,
      pageModalData,
      showImg,
    });

    return (
      <Fragment>
        {this.renderPopup()}
        <CurrentBlocks
          currentLang={currentLanguage}
          selectedSubTab={selectedSubTab}
          selectedType={selectedType}
          selectedBuilding={selectedSubTab}
          handleClick={(selectedModal) => {
            this.handleClickForOpenModal(selectedModal);
          }}
        />
        <Fragment>
          <div className="siteplan-button-group-subtabs">
            <ButtonGroup
              value={selectedType}
              items={_.get(pageModalData, "buttons")}
              onChange={(value) => {
                this.setState({ selectedType: value, popupHover: value });
                setTimeout(() => {
                  this.setState({
                    popupHover: "",
                  });
                }, 10000);
              }}
              direction={width < 992 ? "horizontal" : "vertical"}
              renderItem={({ value, title, active, onClick }) => {
                return (
                  <Button
                    key={value}
                    type="secondary"
                    active={active}
                    activeStyle={{ backgroundColor: "#00a9a5" }}
                    hoverStyle={{ backgroundColor: "#00a9a5" }}
                    defaultStyle={{
                      padding: "12px 17px",
                      marginRight: "2px",
                      fontWeight: "bold",
                      fontSize: "13px",
                      letterSpacing: "1px",
                    }}
                    onClick={onClick}
                  >
                    {t(title)}
                  </Button>
                );
              }}
            />
          </div>
          <div className="button-slider">
            <button
              onClick={this.handleSliderLeft}
              className="button-scroll-to-section left"
            >
              <ArrowLeft width={40} height={40} fill="#04a8a6" />
            </button>

            <button
              onClick={this.handleSliderRight}
              className="button-scroll-to-section right"
            >
              <ArrowRight width={40} height={40} fill="#04a8a6" />
            </button>
          </div>
        </Fragment>
        {/* {selectedSubTab !== "all" && (
          <Fragment>
            <div className="siteplan-button-group-subtabs">
              <ButtonGroup
                value={selectedType}
                items={_.get(pageModalData, "buttons")}
                onChange={(value) => {
                  this.setState({ selectedType: value, popupHover: value });
                  setTimeout(() => {
                    this.setState({
                      popupHover: "",
                    });
                  }, 10000);
                }}
                direction={width < 992 ? "horizontal" : "vertical"}
                renderItem={({ value, title, active, onClick }) => {
                  console.log("SEASIDE RESIDENCES SITE-PLAN RENDER-ITEM", {
                    value,
                    title,
                  });
                  return (
                    <Button
                      key={value}
                      type="secondary"
                      active={active}
                      activeStyle={{ backgroundColor: "#00a9a5" }}
                      hoverStyle={{ backgroundColor: "#00a9a5" }}
                      defaultStyle={{
                        padding: "12px 17px",
                        marginRight: "2px",
                        fontWeight: "bold",
                        fontSize: "13px",
                        letterSpacing: "1px",
                      }}
                      onClick={onClick}
                    >
                      {t(title)}
                    </Button>
                  );
                }}
              />
            </div>
            {selectedSubTab !== "d" && (
              <div className="button-slider">
                <button
                  onClick={this.handleSliderLeft}
                  className="button-scroll-to-section left"
                >
                  <ArrowLeft width={40} height={40} fill="#04a8a6" />
                </button>

                <button
                  onClick={this.handleSliderRight}
                  className="button-scroll-to-section right"
                >
                  <ArrowRight width={40} height={40} fill="#04a8a6" />
                </button>
              </div>
            )}
          </Fragment>
        )} */}
      </Fragment>
    );
  };

  render() {
    const { t, currentLanguage, page, subTabs, dataSitePlan } = this.props;

    const { pageModalData, selectedSubTab } = this.state;

    // loop สร้าง siteplan ตาม floor และเมื่อคลิก floor ให้โชว์ popup 3 menu คลิก menu ไหนให้ filter โชว์แค่อันนั้น
    // const CurrentBuildingPlan = _.get(pageModalData, `floorPlan.${currentLanguage}`);
    // let CurrentBuildingPlan = () => {
    //   return null;
    // };
    // if (pageModalData) {
    //   CurrentBuildingPlan = pageModalData.floorPlan[selectedSubTab];
    // }
    // var MyComponent = Components[type + "Component"];
    // return React.createElement(MyComponent, {});
    return (
      <div className={`section-siteplan ${page} site-plan-has-menu`}>
        {this.renderAllFloor()}
        <div className="siteplan-container-buttongroup">
          <ButtonGroup
            value={selectedSubTab}
            items={subTabs}
            direction="horizontal"
            renderItem={({ value, title, showModal, active, onClick }) => {
              return (
                <Fragment>
                  <Button
                    key={value}
                    type="secondary"
                    active={active}
                    activeStyle={{ backgroundColor: "#00a9a5" }}
                    hoverStyle={{ backgroundColor: "#00a9a5" }}
                    defaultStyle={{
                      padding: "12px 17px",
                      marginRight: "2px",
                      fontWeight: "bold",
                      fontSize: "13px",
                      letterSpacing: "1px",
                    }}
                    onClick={() => {
                      console.log("SVG-FLOOR-CHANGE", { showModal, value });
                      if (showModal === true) {
                        this.handleClickForOpenModalSiteplan(value);
                      } else {
                        this.handleBlock(value);
                      }
                    }}
                  >
                    {t(title)}
                  </Button>
                </Fragment>
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LagunaSeasideResidences/Siteplan.js